export const IN_USE = 'in_use';
export const NOT_USED = 'not_used';
export const USED_WITH_FAILURE = 'used_with_failure';
export const USED_WITH_SUCCESS = 'used_with_success';
